/**
 * Country SEO i18n - Wave 4
 * Expands language coverage for countries missing translations in SV, DA, TR, KO, JA
 * Also adds remaining languages for core countries: sweden, denmark, poland, turkey, scandinavia
 */

import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE4: CountrySEOMap = {

  // ============ FRANCE — expand to SV, DA, KO, TR ============
  france: {
    sv: {
      title: 'Callcenter för Frankrike | Fransktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Frankrike: modersmålstalande franska agenter, CSAT 95%, från 3 $/h. 60% besparing vs Paris.',
      heroTitle: 'Callcenter för Frankrike — Fransktalande Support',
      heroSubtitle: 'Premium kundtjänst på franska till nearshore-priser.',
    },
    da: {
      title: 'Callcenter for Frankrig | Fransktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Frankrig: modersmålstalende franske agenter, CSAT 95%, fra 3 $/t. 60% besparelse vs Paris.',
      heroTitle: 'Callcenter for Frankrig — Fransktalende Support',
      heroSubtitle: 'Premium kundeservice på fransk til nearshore-priser.',
    },
    ko: {
      title: '프랑스 콜센터 | 프랑스어 고객 서비스 | Call IT Dev',
      description: '프랑스 콜센터: 원어민 프랑스어 상담원, CSAT 95%, 시간당 $3부터. 파리 대비 60% 절감.',
      heroTitle: '프랑스 콜센터 — 프랑스어 원어민 지원',
      heroSubtitle: '프리미엄 프랑스어 고객 서비스를 니어쇼어 가격으로.',
    },
    tr: {
      title: 'Fransa Çağrı Merkezi | Fransızca Müşteri Hizmetleri | Call IT Dev',
      description: 'Fransa çağrı merkezi: anadil Fransızca temsilciler, CSAT %95, saat başı 3$\'dan. Paris\'e kıyasla %60 tasarruf.',
      heroTitle: 'Fransa Çağrı Merkezi — Fransızca Destek',
      heroSubtitle: 'Premium Fransızca müşteri hizmetleri nearshore fiyatlarla.',
    },
  },

  // ============ GERMANY — expand to SV, DA, KO, JA ============
  germany: {
    sv: {
      title: 'Callcenter för Tyskland | Tysktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Tyskland: modersmålstalande tyska agenter, CSAT 95%, från 3 $/h. 65% besparing vs Berlin.',
      heroTitle: 'Callcenter för Tyskland — Tysktalande Support',
      heroSubtitle: 'Premium kundtjänst på tyska till nearshore-priser.',
    },
    da: {
      title: 'Callcenter for Tyskland | Tysktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Tyskland: modersmålstalende tyske agenter, CSAT 95%, fra 3 $/t. 65% besparelse vs Berlin.',
      heroTitle: 'Callcenter for Tyskland — Tysktalende Support',
      heroSubtitle: 'Premium kundeservice på tysk til nearshore-priser.',
    },
    ko: {
      title: '독일 콜센터 | 독일어 고객 서비스 | Call IT Dev',
      description: '독일 콜센터: 원어민 독일어 상담원, CSAT 95%, 시간당 $3부터. 베를린 대비 65% 절감.',
      heroTitle: '독일 콜센터 — 독일어 원어민 지원',
      heroSubtitle: '프리미엄 독일어 고객 서비스를 니어쇼어 가격으로.',
    },
    ja: {
      title: 'ドイツ向けコールセンター | ドイツ語カスタマーサービス | Call IT Dev',
      description: 'ドイツ向けコールセンター：ネイティブドイツ語エージェント、CSAT 95%、時給3ドルから。ベルリン比65%節約。',
      heroTitle: 'ドイツ向けコールセンター — ドイツ語ネイティブサポート',
      heroSubtitle: 'プレミアムドイツ語カスタマーサービスをニアショア価格で。',
    },
  },

  // ============ UK — expand to SV, DA, KO, TR, JA ============
  uk: {
    sv: {
      title: 'Callcenter för Storbritannien | Engelsktalande Support | Call IT Dev',
      description: 'Callcenter för Storbritannien: modersmål engelska, CSAT 95%, från 3 $/h. 70% besparing vs London.',
      heroTitle: 'Callcenter för Storbritannien',
      heroSubtitle: 'Premium engelsktalande kundtjänst till nearshore-priser.',
    },
    da: {
      title: 'Callcenter for Storbritannien | Engelsktalende Support | Call IT Dev',
      description: 'Callcenter for Storbritannien: modersmål engelsk, CSAT 95%, fra 3 $/t. 70% besparelse vs London.',
      heroTitle: 'Callcenter for Storbritannien',
      heroSubtitle: 'Premium engelsktalende kundeservice til nearshore-priser.',
    },
    ko: {
      title: '영국 콜센터 | 영어 고객 서비스 | Call IT Dev',
      description: '영국 콜센터: 원어민 영어 상담원, CSAT 95%, 시간당 $3부터. 런던 대비 70% 절감.',
      heroTitle: '영국 콜센터 — 영어 원어민 지원',
      heroSubtitle: '프리미엄 영어 고객 서비스를 니어쇼어 가격으로.',
    },
    tr: {
      title: 'İngiltere Çağrı Merkezi | İngilizce Müşteri Hizmetleri | Call IT Dev',
      description: 'İngiltere çağrı merkezi: anadil İngilizce temsilciler, CSAT %95, saat başı 3$\'dan. Londra\'ya kıyasla %70 tasarruf.',
      heroTitle: 'İngiltere Çağrı Merkezi — İngilizce Destek',
      heroSubtitle: 'Premium İngilizce müşteri hizmetleri nearshore fiyatlarla.',
    },
    ja: {
      title: 'イギリス向けコールセンター | 英語カスタマーサービス | Call IT Dev',
      description: 'イギリス向けコールセンター：ネイティブ英語エージェント、CSAT 95%、時給3ドルから。ロンドン比70%節約。',
      heroTitle: 'イギリス向けコールセンター',
      heroSubtitle: 'プレミアム英語カスタマーサービスをニアショア価格で。',
    },
  },

  // ============ SPAIN — expand to SV, DA, KO, JA, TR ============
  spain: {
    sv: {
      title: 'Callcenter för Spanien | Spansktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Spanien: modersmålstalande spanska agenter, CSAT 95%, från 3 $/h. 60% besparing vs Madrid.',
      heroTitle: 'Callcenter för Spanien — Spansktalande Support',
      heroSubtitle: 'Premium kundtjänst på spanska till nearshore-priser.',
    },
    da: {
      title: 'Callcenter for Spanien | Spansktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Spanien: modersmålstalende spanske agenter, CSAT 95%, fra 3 $/t. 60% besparelse vs Madrid.',
      heroTitle: 'Callcenter for Spanien — Spansktalende Support',
      heroSubtitle: 'Premium kundeservice på spansk til nearshore-priser.',
    },
    ko: {
      title: '스페인 콜센터 | 스페인어 고객 서비스 | Call IT Dev',
      description: '스페인 콜센터: 원어민 스페인어 상담원, CSAT 95%, 시간당 $3부터. 마드리드 대비 60% 절감.',
      heroTitle: '스페인 콜센터 — 스페인어 원어민 지원',
      heroSubtitle: '프리미엄 스페인어 고객 서비스를 니어쇼어 가격으로.',
    },
    ja: {
      title: 'スペイン向けコールセンター | スペイン語カスタマーサービス | Call IT Dev',
      description: 'スペイン向けコールセンター：ネイティブスペイン語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'スペイン向けコールセンター — スペイン語サポート',
      heroSubtitle: 'プレミアムスペイン語カスタマーサービスをニアショア価格で。',
    },
    tr: {
      title: 'İspanya Çağrı Merkezi | İspanyolca Müşteri Hizmetleri | Call IT Dev',
      description: 'İspanya çağrı merkezi: anadil İspanyolca temsilciler, CSAT %95, saat başı 3$\'dan. %60 tasarruf.',
      heroTitle: 'İspanya Çağrı Merkezi — İspanyolca Destek',
      heroSubtitle: 'Premium İspanyolca müşteri hizmetleri nearshore fiyatlarla.',
    },
  },

  // ============ ITALY — expand to SV, DA, KO, JA, TR ============
  italy: {
    sv: {
      title: 'Callcenter för Italien | Italiensktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Italien: modersmål italienska, CSAT 95%, från 3 $/h. 60% besparing vs Milano.',
      heroTitle: 'Callcenter för Italien — Italiensktalande Support',
      heroSubtitle: 'Premium kundtjänst på italienska till nearshore-priser.',
    },
    da: {
      title: 'Callcenter for Italien | Italiensktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Italien: modersmål italiensk, CSAT 95%, fra 3 $/t. 60% besparelse vs Milano.',
      heroTitle: 'Callcenter for Italien — Italiensktalende Support',
      heroSubtitle: 'Premium kundeservice på italiensk til nearshore-priser.',
    },
    ko: {
      title: '이탈리아 콜센터 | 이탈리아어 고객 서비스 | Call IT Dev',
      description: '이탈리아 콜센터: 원어민 이탈리아어 상담원, CSAT 95%, 시간당 $3부터. 밀라노 대비 60% 절감.',
      heroTitle: '이탈리아 콜센터 — 이탈리아어 원어민 지원',
      heroSubtitle: '프리미엄 이탈리아어 고객 서비스를 니어쇼어 가격으로.',
    },
    ja: {
      title: 'イタリア向けコールセンター | イタリア語カスタマーサービス | Call IT Dev',
      description: 'イタリア向けコールセンター：ネイティブイタリア語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'イタリア向けコールセンター — イタリア語サポート',
      heroSubtitle: 'プレミアムイタリア語カスタマーサービスをニアショア価格で。',
    },
    tr: {
      title: 'İtalya Çağrı Merkezi | İtalyanca Müşteri Hizmetleri | Call IT Dev',
      description: 'İtalya çağrı merkezi: anadil İtalyanca temsilciler, CSAT %95, saat başı 3$\'dan. %60 tasarruf.',
      heroTitle: 'İtalya Çağrı Merkezi — İtalyanca Destek',
      heroSubtitle: 'Premium İtalyanca müşteri hizmetleri nearshore fiyatlarla.',
    },
  },

  // ============ NETHERLANDS — expand to SV, DA, KO, JA, TR ============
  netherlands: {
    sv: {
      title: 'Callcenter för Nederländerna | Nederländsktalande Support | Call IT Dev',
      description: 'Callcenter för Nederländerna: modersmål nederländska, CSAT 95%, från 3 $/h. 65% besparing vs Amsterdam.',
      heroTitle: 'Callcenter för Nederländerna',
      heroSubtitle: 'Premium nederländsktalande kundtjänst till nearshore-priser.',
    },
    da: {
      title: 'Callcenter for Holland | Hollandsktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Holland: modersmål hollandsk, CSAT 95%, fra 3 $/t. 65% besparelse vs Amsterdam.',
      heroTitle: 'Callcenter for Holland',
      heroSubtitle: 'Premium hollandsktalende kundeservice til nearshore-priser.',
    },
    ko: {
      title: '네덜란드 콜센터 | 네덜란드어 고객 서비스 | Call IT Dev',
      description: '네덜란드 콜센터: 원어민 네덜란드어 상담원, CSAT 95%, 시간당 $3부터. 암스테르담 대비 65% 절감.',
      heroTitle: '네덜란드 콜센터',
      heroSubtitle: '프리미엄 네덜란드어 고객 서비스를 니어쇼어 가격으로.',
    },
    ja: {
      title: 'オランダ向けコールセンター | オランダ語カスタマーサービス | Call IT Dev',
      description: 'オランダ向けコールセンター：ネイティブオランダ語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'オランダ向けコールセンター',
      heroSubtitle: 'プレミアムオランダ語カスタマーサービスをニアショア価格で。',
    },
    tr: {
      title: 'Hollanda Çağrı Merkezi | Hollandaca Müşteri Hizmetleri | Call IT Dev',
      description: 'Hollanda çağrı merkezi: anadil Hollandaca temsilciler, CSAT %95, saat başı 3$\'dan. %65 tasarruf.',
      heroTitle: 'Hollanda Çağrı Merkezi',
      heroSubtitle: 'Premium Hollandaca müşteri hizmetleri nearshore fiyatlarla.',
    },
  },

  // ============ SWITZERLAND — expand to SV, DA, KO, JA, TR ============
  switzerland: {
    sv: {
      title: 'Callcenter för Schweiz | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Schweiz: tyska, franska, italienska agenter, CSAT 95%, från 3 $/h. 70% besparing vs Zürich.',
      heroTitle: 'Callcenter för Schweiz',
      heroSubtitle: 'Flerspråkig kundtjänst till nearshore-priser.',
    },
    da: {
      title: 'Callcenter for Schweiz | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter for Schweiz: tyske, franske, italienske agenter, CSAT 95%, fra 3 $/t. 70% besparelse vs Zürich.',
      heroTitle: 'Callcenter for Schweiz',
      heroSubtitle: 'Flersproget kundeservice til nearshore-priser.',
    },
    ko: {
      title: '스위스 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '스위스 콜센터: 독일어, 프랑스어, 이탈리아어 상담원, CSAT 95%, 시간당 $3부터. 취리히 대비 70% 절감.',
      heroTitle: '스위스 콜센터',
      heroSubtitle: '프리미엄 다국어 고객 서비스를 니어쇼어 가격으로.',
    },
    ja: {
      title: 'スイス向けコールセンター | 多言語カスタマーサービス | Call IT Dev',
      description: 'スイス向けコールセンター：ドイツ語、フランス語、イタリア語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'スイス向けコールセンター',
      heroSubtitle: 'プレミアム多言語カスタマーサービスをニアショア価格で。',
    },
    tr: {
      title: 'İsviçre Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'İsviçre çağrı merkezi: Almanca, Fransızca, İtalyanca temsilciler, CSAT %95, saat başı 3$\'dan. %70 tasarruf.',
      heroTitle: 'İsviçre Çağrı Merkezi',
      heroSubtitle: 'Premium çok dilli müşteri hizmetleri nearshore fiyatlarla.',
    },
  },

  // ============ BELGIUM — expand to SV, DA, KO, JA, TR ============
  belgium: {
    sv: {
      title: 'Callcenter för Belgien | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Belgien: franska, nederländska agenter, CSAT 95%, från 3 $/h. 60% besparing vs Bryssel.',
      heroTitle: 'Callcenter för Belgien',
      heroSubtitle: 'Flerspråkig kundtjänst för belgiska företag.',
    },
    da: {
      title: 'Callcenter for Belgien | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter for Belgien: franske, hollandske agenter, CSAT 95%, fra 3 $/t. 60% besparelse vs Bruxelles.',
      heroTitle: 'Callcenter for Belgien',
      heroSubtitle: 'Flersproget kundeservice for belgiske virksomheder.',
    },
    ko: {
      title: '벨기에 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '벨기에 콜센터: 프랑스어, 네덜란드어 상담원, CSAT 95%, 시간당 $3부터. 브뤼셀 대비 60% 절감.',
      heroTitle: '벨기에 콜센터',
      heroSubtitle: '벨기에 기업을 위한 다국어 고객 서비스.',
    },
    ja: {
      title: 'ベルギー向けコールセンター | 多言語カスタマーサービス | Call IT Dev',
      description: 'ベルギー向けコールセンター：フランス語、オランダ語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'ベルギー向けコールセンター',
      heroSubtitle: 'ベルギー企業向け多言語カスタマーサービス。',
    },
    tr: {
      title: 'Belçika Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'Belçika çağrı merkezi: Fransızca, Hollandaca temsilciler, CSAT %95, saat başı 3$\'dan. %60 tasarruf.',
      heroTitle: 'Belçika Çağrı Merkezi',
      heroSubtitle: 'Belçika şirketleri için çok dilli müşteri hizmetleri.',
    },
  },

  // ============ PORTUGAL — expand to SV, DA, KO, JA, TR ============
  portugal: {
    sv: {
      title: 'Callcenter för Portugal | Portugisisktalande Support | Call IT Dev',
      description: 'Callcenter för Portugal: modersmål portugisiska, CSAT 95%, från 3 $/h. 55% besparing vs Lissabon.',
      heroTitle: 'Callcenter för Portugal',
      heroSubtitle: 'Premium portugisisktalande kundtjänst.',
    },
    da: {
      title: 'Callcenter for Portugal | Portugisisktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Portugal: modersmål portugisisk, CSAT 95%, fra 3 $/t. 55% besparelse vs Lissabon.',
      heroTitle: 'Callcenter for Portugal',
      heroSubtitle: 'Premium portugisisktalende kundeservice.',
    },
    ko: {
      title: '포르투갈 콜센터 | 포르투갈어 고객 서비스 | Call IT Dev',
      description: '포르투갈 콜센터: 원어민 포르투갈어 상담원, CSAT 95%, 시간당 $3부터. 리스본 대비 55% 절감.',
      heroTitle: '포르투갈 콜센터',
      heroSubtitle: '프리미엄 포르투갈어 고객 서비스.',
    },
    ja: {
      title: 'ポルトガル向けコールセンター | ポルトガル語サポート | Call IT Dev',
      description: 'ポルトガル向けコールセンター：ネイティブポルトガル語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'ポルトガル向けコールセンター',
      heroSubtitle: 'プレミアムポルトガル語カスタマーサービス。',
    },
    tr: {
      title: 'Portekiz Çağrı Merkezi | Portekizce Müşteri Hizmetleri | Call IT Dev',
      description: 'Portekiz çağrı merkezi: anadil Portekizce temsilciler, CSAT %95, saat başı 3$\'dan. %55 tasarruf.',
      heroTitle: 'Portekiz Çağrı Merkezi',
      heroSubtitle: 'Premium Portekizce müşteri hizmetleri.',
    },
  },

  // ============ SCANDINAVIA — expand to KO, JA, TR ============
  scandinavia: {
    ko: {
      title: '스칸디나비아 콜센터 | 북유럽 고객 서비스 | Call IT Dev',
      description: '스칸디나비아 콜센터: 스웨덴어, 덴마크어, 노르웨이어 상담원, CSAT 95%, 시간당 $3부터.',
      heroTitle: '스칸디나비아 콜센터',
      heroSubtitle: '북유럽 기업을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'スカンジナビア向けコールセンター | 北欧カスタマーサービス | Call IT Dev',
      description: 'スカンジナビア向けコールセンター：スウェーデン語、デンマーク語、ノルウェー語エージェント、CSAT 95%。',
      heroTitle: 'スカンジナビア向けコールセンター',
      heroSubtitle: '北欧企業向けプレミアムカスタマーサービス。',
    },
    tr: {
      title: 'İskandinavya Çağrı Merkezi | Nordik Müşteri Hizmetleri | Call IT Dev',
      description: 'İskandinavya çağrı merkezi: İsveççe, Danca, Norveççe temsilciler, CSAT %95, saat başı 3$\'dan.',
      heroTitle: 'İskandinavya Çağrı Merkezi',
      heroSubtitle: 'Nordik şirketleri için premium müşteri hizmetleri.',
    },
  },

  // ============ SWEDEN — expand to KO, JA, TR, IT, PT, NL ============
  sweden: {
    ko: {
      title: '스웨덴 콜센터 | 스웨덴어 고객 서비스 | Call IT Dev',
      description: '스웨덴 콜센터: 스웨덴어 상담원, CSAT 95%, 시간당 $3부터. 스톡홀름 대비 65% 절감.',
      heroTitle: '스웨덴 콜센터',
      heroSubtitle: '스웨덴 기업을 위한 니어쇼어 고객 서비스.',
    },
    ja: {
      title: 'スウェーデン向けコールセンター | スウェーデン語サポート | Call IT Dev',
      description: 'スウェーデン向けコールセンター：スウェーデン語エージェント、CSAT 95%、時給3ドルから。ストックホルム比65%節約。',
      heroTitle: 'スウェーデン向けコールセンター',
      heroSubtitle: 'スウェーデン企業向けニアショアカスタマーサービス。',
    },
    tr: {
      title: 'İsveç Çağrı Merkezi | İsveççe Müşteri Hizmetleri | Call IT Dev',
      description: 'İsveç çağrı merkezi: İsveççe temsilciler, CSAT %95, saat başı 3$\'dan. Stockholm\'e kıyasla %65 tasarruf.',
      heroTitle: 'İsveç Çağrı Merkezi',
      heroSubtitle: 'İsveç şirketleri için nearshore müşteri hizmetleri.',
    },
    it: {
      title: 'Call Center Svezia | Assistenza Clienti Svedese | Call IT Dev',
      description: 'Call center per la Svezia: agenti svedesi, CSAT 95%, da 3 $/h. 65% risparmio vs Stoccolma.',
      heroTitle: 'Call Center per la Svezia',
      heroSubtitle: 'Assistenza clienti premium nearshore per aziende svedesi.',
    },
    pt: {
      title: 'Call Center Suécia | Atendimento ao Cliente Sueco | Call IT Dev',
      description: 'Call center para a Suécia: agentes suecos, CSAT 95%, a partir de 3 $/h. 65% economia vs Estocolmo.',
      heroTitle: 'Call Center para a Suécia',
      heroSubtitle: 'Atendimento premium nearshore para empresas suecas.',
    },
    nl: {
      title: 'Callcenter Zweden | Zweedstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Zweden: Zweedstalige agenten, CSAT 95%, vanaf 3 $/u. 65% besparing vs Stockholm.',
      heroTitle: 'Callcenter voor Zweden',
      heroSubtitle: 'Premium nearshore klantenservice voor Zweedse bedrijven.',
    },
  },

  // ============ DENMARK — expand to KO, JA, TR, IT, PT, NL ============
  denmark: {
    ko: {
      title: '덴마크 콜센터 | 덴마크어 고객 서비스 | Call IT Dev',
      description: '덴마크 콜센터: 덴마크어 상담원, CSAT 95%, 시간당 $3부터. 코펜하겐 대비 60% 절감.',
      heroTitle: '덴마크 콜센터',
      heroSubtitle: '덴마크 기업을 위한 니어쇼어 고객 서비스.',
    },
    ja: {
      title: 'デンマーク向けコールセンター | デンマーク語サポート | Call IT Dev',
      description: 'デンマーク向けコールセンター：デンマーク語エージェント、CSAT 95%、時給3ドルから。コペンハーゲン比60%節約。',
      heroTitle: 'デンマーク向けコールセンター',
      heroSubtitle: 'デンマーク企業向けニアショアカスタマーサービス。',
    },
    tr: {
      title: 'Danimarka Çağrı Merkezi | Danca Müşteri Hizmetleri | Call IT Dev',
      description: 'Danimarka çağrı merkezi: Danca temsilciler, CSAT %95, saat başı 3$\'dan. Kopenhag\'a kıyasla %60 tasarruf.',
      heroTitle: 'Danimarka Çağrı Merkezi',
      heroSubtitle: 'Danimarka şirketleri için nearshore müşteri hizmetleri.',
    },
    it: {
      title: 'Call Center Danimarca | Assistenza Clienti Danese | Call IT Dev',
      description: 'Call center per la Danimarca: agenti danesi, CSAT 95%, da 3 $/h. 60% risparmio vs Copenaghen.',
      heroTitle: 'Call Center per la Danimarca',
      heroSubtitle: 'Assistenza clienti premium nearshore per aziende danesi.',
    },
    pt: {
      title: 'Call Center Dinamarca | Atendimento ao Cliente Dinamarquês | Call IT Dev',
      description: 'Call center para a Dinamarca: agentes dinamarqueses, CSAT 95%, a partir de 3 $/h. 60% economia vs Copenhague.',
      heroTitle: 'Call Center para a Dinamarca',
      heroSubtitle: 'Atendimento premium nearshore para empresas dinamarquesas.',
    },
    nl: {
      title: 'Callcenter Denemarken | Deenstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Denemarken: Deenstalige agenten, CSAT 95%, vanaf 3 $/u. 60% besparing vs Kopenhagen.',
      heroTitle: 'Callcenter voor Denemarken',
      heroSubtitle: 'Premium nearshore klantenservice voor Deense bedrijven.',
    },
  },

  // ============ TURKEY — expand to SV, DA, KO, JA ============
  turkey: {
    sv: {
      title: 'Callcenter för Turkiet | Turkisktalande Support | Call IT Dev',
      description: 'Callcenter för Turkiet: modersmål turkiska, CSAT 95%, från 3 $/h. 50% besparing vs Istanbul.',
      heroTitle: 'Callcenter för Turkiet',
      heroSubtitle: 'Premium turkisktalande kundtjänst till nearshore-priser.',
    },
    da: {
      title: 'Callcenter for Tyrkiet | Tyrkisktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Tyrkiet: modersmål tyrkisk, CSAT 95%, fra 3 $/t. 50% besparelse vs Istanbul.',
      heroTitle: 'Callcenter for Tyrkiet',
      heroSubtitle: 'Premium tyrkisktalende kundeservice til nearshore-priser.',
    },
    ko: {
      title: '터키 콜센터 | 터키어 고객 서비스 | Call IT Dev',
      description: '터키 콜센터: 원어민 터키어 상담원, CSAT 95%, 시간당 $3부터. 이스탄불 대비 50% 절감.',
      heroTitle: '터키 콜센터',
      heroSubtitle: '터키 기업을 위한 니어쇼어 고객 서비스.',
    },
    ja: {
      title: 'トルコ向けコールセンター | トルコ語カスタマーサービス | Call IT Dev',
      description: 'トルコ向けコールセンター：ネイティブトルコ語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'トルコ向けコールセンター',
      heroSubtitle: 'トルコ企業向けニアショアカスタマーサービス。',
    },
  },

  // ============ POLAND — expand to SV, DA, KO, JA, TR ============
  poland: {
    sv: {
      title: 'Callcenter för Polen | Polsktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Polen: modersmål polska, CSAT 95%, från 3 $/h. 50% besparing vs Warszawa.',
      heroTitle: 'Callcenter för Polen',
      heroSubtitle: 'Premium polsktalande kundtjänst till nearshore-priser.',
    },
    da: {
      title: 'Callcenter for Polen | Polsktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Polen: modersmål polsk, CSAT 95%, fra 3 $/t. 50% besparelse vs Warszawa.',
      heroTitle: 'Callcenter for Polen',
      heroSubtitle: 'Premium polsktalende kundeservice til nearshore-priser.',
    },
    ko: {
      title: '폴란드 콜센터 | 폴란드어 고객 서비스 | Call IT Dev',
      description: '폴란드 콜센터: 원어민 폴란드어 상담원, CSAT 95%, 시간당 $3부터. 바르샤바 대비 50% 절감.',
      heroTitle: '폴란드 콜센터',
      heroSubtitle: '폴란드 기업을 위한 니어쇼어 고객 서비스.',
    },
    ja: {
      title: 'ポーランド向けコールセンター | ポーランド語カスタマーサービス | Call IT Dev',
      description: 'ポーランド向けコールセンター：ネイティブポーランド語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'ポーランド向けコールセンター',
      heroSubtitle: 'ポーランド企業向けニアショアカスタマーサービス。',
    },
    tr: {
      title: 'Polonya Çağrı Merkezi | Lehçe Müşteri Hizmetleri | Call IT Dev',
      description: 'Polonya çağrı merkezi: anadil Lehçe temsilciler, CSAT %95, saat başı 3$\'dan. %50 tasarruf.',
      heroTitle: 'Polonya Çağrı Merkezi',
      heroSubtitle: 'Polonya şirketleri için nearshore müşteri hizmetleri.',
    },
  },

  // ============ UAE — expand to SV, DA, KO, JA ============
  uae: {
    sv: {
      title: 'Callcenter för Förenade Arabemiraten | Arabisktalande Support | Call IT Dev',
      description: 'Callcenter för UAE: modersmål arabiska, CSAT 95%, från 3 $/h. 65% besparing vs Dubai.',
      heroTitle: 'Callcenter för Förenade Arabemiraten',
      heroSubtitle: 'Premium arabisktalande kundtjänst till nearshore-priser.',
    },
    da: {
      title: 'Callcenter for De Forenede Arabiske Emirater | Arabisktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for UAE: modersmål arabisk, CSAT 95%, fra 3 $/t. 65% besparelse vs Dubai.',
      heroTitle: 'Callcenter for De Forenede Arabiske Emirater',
      heroSubtitle: 'Premium arabisktalende kundeservice til nearshore-priser.',
    },
    ko: {
      title: 'UAE 콜센터 | 아랍어 고객 서비스 | Call IT Dev',
      description: 'UAE 콜센터: 원어민 아랍어 상담원, CSAT 95%, 시간당 $3부터. 두바이 대비 65% 절감.',
      heroTitle: 'UAE 콜센터',
      heroSubtitle: 'UAE 기업을 위한 니어쇼어 고객 서비스.',
    },
    ja: {
      title: 'UAE向けコールセンター | アラビア語カスタマーサービス | Call IT Dev',
      description: 'UAE向けコールセンター：ネイティブアラビア語エージェント、CSAT 95%、時給3ドルから。ドバイ比65%節約。',
      heroTitle: 'UAE向けコールセンター',
      heroSubtitle: 'UAE企業向けニアショアカスタマーサービス。',
    },
  },

  // ============ QATAR — expand to SV, DA, KO, JA, TR ============
  qatar: {
    sv: {
      title: 'Callcenter för Qatar | Arabisktalande Support | Call IT Dev',
      description: 'Callcenter för Qatar: modersmål arabiska, CSAT 95%, från 3 $/h. 65% besparing vs Doha.',
      heroTitle: 'Callcenter för Qatar',
      heroSubtitle: 'Premium arabisktalande kundtjänst för Qatar.',
    },
    da: {
      title: 'Callcenter for Qatar | Arabisktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Qatar: modersmål arabisk, CSAT 95%, fra 3 $/t. 65% besparelse vs Doha.',
      heroTitle: 'Callcenter for Qatar',
      heroSubtitle: 'Premium arabisktalende kundeservice for Qatar.',
    },
    ko: {
      title: '카타르 콜센터 | 아랍어 고객 서비스 | Call IT Dev',
      description: '카타르 콜센터: 원어민 아랍어 상담원, CSAT 95%, 시간당 $3부터. 도하 대비 65% 절감.',
      heroTitle: '카타르 콜센터',
      heroSubtitle: '카타르 기업을 위한 니어쇼어 고객 서비스.',
    },
    ja: {
      title: 'カタール向けコールセンター | アラビア語サポート | Call IT Dev',
      description: 'カタール向けコールセンター：ネイティブアラビア語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'カタール向けコールセンター',
      heroSubtitle: 'カタール企業向けニアショアカスタマーサービス。',
    },
    tr: {
      title: 'Katar Çağrı Merkezi | Arapça Müşteri Hizmetleri | Call IT Dev',
      description: 'Katar çağrı merkezi: anadil Arapça temsilciler, CSAT %95, saat başı 3$\'dan. %65 tasarruf.',
      heroTitle: 'Katar Çağrı Merkezi',
      heroSubtitle: 'Katar şirketleri için nearshore müşteri hizmetleri.',
    },
  },

  // ============ CANADA — expand to SV, DA, KO, JA, TR ============
  canada: {
    sv: {
      title: 'Callcenter för Kanada | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Kanada: franska och engelska agenter, CSAT 95%, från 3 $/h. 65% besparing vs Toronto.',
      heroTitle: 'Callcenter för Kanada',
      heroSubtitle: 'Flerspråkig kundtjänst för kanadensiska företag.',
    },
    da: {
      title: 'Callcenter for Canada | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter for Canada: franske og engelske agenter, CSAT 95%, fra 3 $/t. 65% besparelse vs Toronto.',
      heroTitle: 'Callcenter for Canada',
      heroSubtitle: 'Flersproget kundeservice for canadiske virksomheder.',
    },
    ko: {
      title: '캐나다 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '캐나다 콜센터: 프랑스어, 영어 상담원, CSAT 95%, 시간당 $3부터. 토론토 대비 65% 절감.',
      heroTitle: '캐나다 콜센터',
      heroSubtitle: '캐나다 기업을 위한 다국어 고객 서비스.',
    },
    ja: {
      title: 'カナダ向けコールセンター | 多言語カスタマーサービス | Call IT Dev',
      description: 'カナダ向けコールセンター：フランス語、英語エージェント、CSAT 95%、時給3ドルから。トロント比65%節約。',
      heroTitle: 'カナダ向けコールセンター',
      heroSubtitle: 'カナダ企業向け多言語カスタマーサービス。',
    },
    tr: {
      title: 'Kanada Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'Kanada çağrı merkezi: Fransızca ve İngilizce temsilciler, CSAT %95, saat başı 3$\'dan. %65 tasarruf.',
      heroTitle: 'Kanada Çağrı Merkezi',
      heroSubtitle: 'Kanada şirketleri için çok dilli müşteri hizmetleri.',
    },
  },

  // ============ USA — expand to SV, DA, KO, JA, TR ============
  usa: {
    sv: {
      title: 'Callcenter för USA | Engelsktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för USA: modersmål engelska, CSAT 95%, från 3 $/h. 70% besparing vs New York.',
      heroTitle: 'Callcenter för USA',
      heroSubtitle: 'Premium engelsktalande kundtjänst för amerikanska företag.',
    },
    da: {
      title: 'Callcenter for USA | Engelsktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for USA: modersmål engelsk, CSAT 95%, fra 3 $/t. 70% besparelse vs New York.',
      heroTitle: 'Callcenter for USA',
      heroSubtitle: 'Premium engelsktalende kundeservice for amerikanske virksomheder.',
    },
    ko: {
      title: '미국 콜센터 | 영어 고객 서비스 | Call IT Dev',
      description: '미국 콜센터: 원어민 영어 상담원, CSAT 95%, 시간당 $3부터. 뉴욕 대비 70% 절감.',
      heroTitle: '미국 콜센터',
      heroSubtitle: '미국 기업을 위한 프리미엄 영어 고객 서비스.',
    },
    ja: {
      title: 'アメリカ向けコールセンター | 英語カスタマーサービス | Call IT Dev',
      description: 'アメリカ向けコールセンター：ネイティブ英語エージェント、CSAT 95%、時給3ドルから。ニューヨーク比70%節約。',
      heroTitle: 'アメリカ向けコールセンター',
      heroSubtitle: 'アメリカ企業向けプレミアム英語カスタマーサービス。',
    },
    tr: {
      title: 'ABD Çağrı Merkezi | İngilizce Müşteri Hizmetleri | Call IT Dev',
      description: 'ABD çağrı merkezi: anadil İngilizce temsilciler, CSAT %95, saat başı 3$\'dan. %70 tasarruf.',
      heroTitle: 'ABD Çağrı Merkezi',
      heroSubtitle: 'Amerikan şirketleri için premium İngilizce müşteri hizmetleri.',
    },
  },

  // ============ INDIA — expand to SV, DA, TR ============
  india: {
    sv: {
      title: 'Callcenter för Indien | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Indien: engelska agenter, CSAT 95%, från 3 $/h. Europeiska språk tillgängliga.',
      heroTitle: 'Callcenter för Indien',
      heroSubtitle: 'Flerspråkig kundtjänst för indiska företag.',
    },
    da: {
      title: 'Callcenter for Indien | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter for Indien: engelske agenter, CSAT 95%, fra 3 $/t. Europæiske sprog tilgængelige.',
      heroTitle: 'Callcenter for Indien',
      heroSubtitle: 'Flersproget kundeservice for indiske virksomheder.',
    },
    tr: {
      title: 'Hindistan Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'Hindistan çağrı merkezi: İngilizce temsilciler, CSAT %95, saat başı 3$\'dan. Avrupa dilleri mevcut.',
      heroTitle: 'Hindistan Çağrı Merkezi',
      heroSubtitle: 'Hint şirketleri için çok dilli müşteri hizmetleri.',
    },
  },

  // ============ AUSTRALIA — expand to SV, DA, TR ============
  australia: {
    sv: {
      title: 'Callcenter för Australien | Engelsktalande Support | Call IT Dev',
      description: 'Callcenter för Australien: modersmål engelska, CSAT 95%, från 3 $/h. 70% besparing vs Sydney.',
      heroTitle: 'Callcenter för Australien',
      heroSubtitle: 'Premium engelsktalande kundtjänst för australiska företag.',
    },
    da: {
      title: 'Callcenter for Australien | Engelsktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Australien: modersmål engelsk, CSAT 95%, fra 3 $/t. 70% besparelse vs Sydney.',
      heroTitle: 'Callcenter for Australien',
      heroSubtitle: 'Premium engelsktalende kundeservice for australske virksomheder.',
    },
    tr: {
      title: 'Avustralya Çağrı Merkezi | İngilizce Müşteri Hizmetleri | Call IT Dev',
      description: 'Avustralya çağrı merkezi: anadil İngilizce temsilciler, CSAT %95, saat başı 3$\'dan. %70 tasarruf.',
      heroTitle: 'Avustralya Çağrı Merkezi',
      heroSubtitle: 'Avustralya şirketleri için premium İngilizce müşteri hizmetleri.',
    },
  },
};
